import { ObservableMap } from '@stencil/store';

import { caseInsensitiveCompare } from '../../utils/helper';
import Logger from '../../utils/logger/logger';
import {
    isFalselyOrWhiteSpace,
    setMenuItems,
} from '../common';
import { State } from '../types/state';

export function setCurrentTenantSideEffect(store: ObservableMap<State>) {
    store.onChange('currentTenant', (tenantNameOrId: string) => {
        if (isFalselyOrWhiteSpace(tenantNameOrId)) {
            return;
        }

        Logger.debug([ 'store', 'tenant', 'change' ], `current selected tenant name/id has changed: ${tenantNameOrId}`, { state: store.state });
        const currentTenantInfo = store.get('currentTenantInfo');
        const tenants = store.get('tenantList');
        const isMatch = caseInsensitiveCompare(currentTenantInfo?.name ?? '', tenantNameOrId)
            || caseInsensitiveCompare(currentTenantInfo?.id ?? '', tenantNameOrId);

        if (!isMatch && tenants && tenants.length > 0) {
            const selectedTenant = tenants.find(
                tenant => caseInsensitiveCompare(tenantNameOrId, tenant.name) || caseInsensitiveCompare(tenantNameOrId, tenant.id),
            );
            if (selectedTenant) {
                store.set('currentTenantInfo', selectedTenant);
            }
        } else if (isMatch) {
            setMenuItems(store);
        }
    });
}
